<cac-dialog-layout title="نمایش درختی" [hideControls]="true">
    <app-tree-view [control]="locationControl" [fieldMode]="true" [multiple]="true" [readonly]="true" mode="external" [externalDataSourse]="data.dataSourse" [highlightedIds]="data.highlightedIds"></app-tree-view>
</cac-dialog-layout>
